import { del, get, patch, postFormData, publicGet } from './core';

export interface OrganizationProfile {
  name: string;
  description: string | null;
  logoUrl: string | null;
}

// Story 092 — admin-only shape adds the four email-identity fields the
// org admin edits from the profile form. The public GET stays minimal.
export interface OrganizationProfileAdmin extends OrganizationProfile {
  emailFromName: string | null;
  emailFromAddress: string | null;
  emailReplyTo: string | null;
  emailListUnsubscribe: string | null;
}

export function getOrgProfile(): Promise<OrganizationProfile> {
  return publicGet('/org-profile');
}

// Story 092 — admin GET returns the four email-identity fields too.
// The org-profile form uses this to populate its inputs and to drive
// the missing-fields banner.
export function getAdminOrgProfile(): Promise<OrganizationProfileAdmin> {
  return get('/admin/org-profile');
}

export function updateOrgProfile(input: {
  name?: string;
  description?: string | null;
  emailFromName?: string | null;
  emailFromAddress?: string | null;
  emailReplyTo?: string | null;
  emailListUnsubscribe?: string | null;
}): Promise<OrganizationProfileAdmin> {
  return patch('/admin/org-profile', input);
}

export function uploadOrgLogo(file: File): Promise<OrganizationProfileAdmin> {
  const form = new FormData();
  form.append('file', file);
  return postFormData<OrganizationProfileAdmin>('/admin/org-profile/logo', form);
}

export function deleteOrgLogo(): Promise<OrganizationProfileAdmin> {
  return del('/admin/org-profile/logo');
}
